import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

/**
 * Slider component
 */
export default class HeroSlider extends withBreakpointObserver(Base) {
  /**
   * Component Configuration
   */
  static config = {
    name: 'HeroSlider',
    refs: ['slider', 'prev', 'next', 'pagination'],
  };

  /**
   *
   */
  mounted() {
    // Respecte prefers-reduced-motion : pas d'autoplay ni d'anneau de charge.
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.slider = new Swiper(this.$refs.slider, {
      modules: [Pagination, Autoplay],
      slidesPerView: 1,
      grabCursor: true,
      loop: true,
      autoplay: prefersReducedMotion
        ? false
        : {
            delay: 5000,
            disableOnInteraction: false,
          },
      pagination: {
        clickable: true,
        el: this.$refs.pagination,
      },
      on: {
        // Répercute la progression de l'autoplay sur le bullet actif via la
        // variable CSS --progress (0% → 100%), qui alimente l'anneau de charge.
        autoplayTimeLeft: (swiper, time, progress) => {
          const active = this.$refs.pagination.querySelector('.swiper-pagination-bullet-active');
          if (active) {
            active.style.setProperty('--progress', `${(1 - progress) * 100}%`);
          }
        },
      },
    });
  }
}
